import React  from 'react';

export default function Footer(){
    return (
        <div className="footer">
            <div className='declaration'>&#169; All rights reserved</div>
           <div>本網頁所提供的資料只作參考用途。對於本網頁所載任何資料的準確性及完整性，本網頁一概拒絕承認任何保証和責任。</div>
           <a rel="noreferrer" href='https://docs.google.com/forms/d/e/1FAIpQLSewIiFAOCxHKEoVMwAZTOT6Vh02lVGxt45iWSL_NVvZpREF_Q/viewform' target="_blank" className='reportinfo'>我要報料</a>
        </div>
    )
};
